export default __webpack_public_path__ + "static/media/480.f2489756.png";